import { StarOutline } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import Loading from "../loader/Loading";

const AddToFavoritesButton = ({
  onClick,
  isDisabled,
  style,
  isLoading,
  text,
}) => {
  return (
    <Tooltip title={!text && "افزودن به علاقمندی‌ها"}>
      <span>
        <button
          style={style}
          onClick={onClick}
          className="btn"
          disabled={isDisabled || isLoading}
        >
          {isLoading ? (
            <Loading size={"5px"} />
          ) : (
            <>
              {text && text}
              <StarOutline />
            </>
          )}
        </button>
      </span>
    </Tooltip>
  );
};

export default AddToFavoritesButton;
